module.exports = __webpack_public_path__ + "img/822-4fbfb4.png";